import { GITHUB_BRANCH_PARAM } from './constants';

export function getExplicitBranch(params: URLSearchParams) {
  return params.get(GITHUB_BRANCH_PARAM);
}
